import { Component, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import grapesjs, { Editor } from 'grapesjs';
// Adjust this import to match your build (e.g. 'ckeditor5' or your local bundle path)
import { 	
  BalloonEditor,
  InlineEditor,
	Autoformat,
	Bold,
	Italic,
	BlockQuote,
	Base64UploadAdapter,
	CloudServices,
	Essentials,
	Heading,
	Image,
	ImageCaption,
	ImageStyle,
	ImageToolbar,
	ImageUpload,
  ImageResizeEditing, 
  ImageResizeHandles,
	PictureEditing,
	Indent,
	Link,
  LinkImage,
	List,
	Mention,
	Paragraph,
	PasteFromOffice,
	Table,
	TableToolbar,
	TextTransformation } from 'ckeditor5';


const LICENSE_KEY = 'GPL';

const ckConfig = { 
  licenseKey: LICENSE_KEY,
  plugins: [
		Essentials,
		Autoformat,
		Bold,
		Italic,
		BlockQuote,
		CloudServices,
		Heading,
		Image,
		ImageCaption,
		ImageStyle,
		ImageToolbar,
		ImageUpload,
    ImageResizeEditing, 
    ImageResizeHandles,
    LinkImage,
		Base64UploadAdapter,
		Indent,
		Link,
		List,
		Mention,
		Paragraph,
		PasteFromOffice,
		PictureEditing,
		Table,
		TableToolbar,
		TextTransformation,
	],
  toolbar: {
    items:[
      'undo',
      'redo',
      '|',
      'heading',
      '|',
      'bold',
      'italic',
      '|',
      'link',
      'insertImage',
      'insertTable',
      'blockQuote',
      '|',
      'bulletedList',
      'numberedList',
      '|',
      'outdent',
      'indent'
    ],
    viewportTopOffset: 100
  },
	
	image: {
		toolbar: [
      'imageStyle:block',
      'imageStyle:side',
      '|',
      'toggleImageCaption',
      'imageTextAlternative',
      '|',
      'linkImage'
    ],

	},
	link: {
		addTargetToExternalLinks: true,
		defaultProtocol: 'https://'
	},
	table: {
		contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
	},
  ui: {
    viewportOffset: { top: 0, right: 0, bottom: -400, left: 0 }
  }
}

@Component({
  selector: 'app-basic-editor',
  templateUrl: './basic-editor.component.html',
  styleUrls: ['./basic-editor.component.scss']
})
export class BasicEditorComponent implements AfterViewInit, OnDestroy {
  @ViewChild('gjsRef', { static: true }) gjsRef!: ElementRef<HTMLDivElement>;
  private editor?: Editor;
  private ckInstances = new WeakMap<HTMLElement, any>();

  ngAfterViewInit(): void {
    // 1) Minimal Grapes init

    const customRTE = (editor) => {

      const focus = (el: HTMLElement, rte) => {
        console.log(el, rte);
        console.log('grapesjs got a focus event')
        rte.focus(); // this depends on the Custom RTE API
      }

      editor.on('component:selected', cmp => {
        console.log('component:selected', cmp)
      });

      editor.setCustomRte({
        enable: async (el: HTMLElement, rte) => {
          // const target = resolveEditableEl(el);
          // target.setAttribute('contenteditable', 'true');
          if (!rte) {
            rte = await BalloonEditor.create(el, ckConfig);
            installIframeEditableGuard(rte, editor);
            // placePoweredByOnEditable(rte, editor);

            rte.editing.view.document.on( 'change:isFocused', ( evt, data, isFocused ) => {
              console.log( `CK View document focus: ${ isFocused }.` );
            } );

            rte.ui.focusTracker.on( 'change:isFocused', ( evt, data, isFocused ) => {
              console.log( `CK editor is focused: ${ isFocused }.` );
            } );

            rte.model.document.on( 'change:data', (eventInfo, batch) => {
              console.log( 'The data has changed!', eventInfo, batch );
              el.focus()
              rte.editing.view.focus()

            } );
          }


          // focus(el, rte)
          // // Make live
          // if (typeof rte.disableReadOnlyMode === 'function') 
          //   rte.disableReadOnlyMode('gjs');
          // else 
          //   rte.isReadOnly = false;

          // NEW: keep image widget selection + balloon working after reselects
          // installImageReselect(rte);

          // rte.editing.view.focus();


          // ck.ui.viewportOffset = {
          //   top: 100,
          //   right: 0,
          //   bottom: 0,
          //   left: 0
          // };
          console.log(rte)
          el.contentEditable = "true";
          return rte;
        },

        disable: async (el: HTMLElement, rte) => {
          // if(event) {
          //   event.preventDefault();
          //   event.stopPropagation();
          //   rte.focus();
          //   console.log('bla bla bla')
          //   return; 
          // }
          editor.select(editor.editor.getComponents()[0].components.models[1]) 

          console.log('trying to detach rte', el)
          el.contentEditable = "true";

            // const target = resolveEditableEl(el);
            // const ck = this.ckInstances.get(target);
            // if (!ck) return;

            // // NEW: tidy up listeners (prevents duplicates)
            // uninstallImageReselect(ck);
            // removeIframeEditableGuard(ck, gjs);

            // (leave your current "do nothing" disable body as-is)

          // //THIS SHOULD WORK, EXCEPT WE ARE STILL GETTING DISABLES CALLED FROM OUTSIDE THE TOOLBAR
          // if (rte) {
          //   const data = rte.getData();
          //   await rte.destroy();
          //   el.innerHTML = data;
          //   el.contentEditable = "false";
          // }

        },

        getContent(el, rte) {
          const htmlString = rte.getData();
          console.log(htmlString)
          el.contentEditable = "true";

          return htmlString;
        },

      });

    }
    this.editor = grapesjs.init({
      container: this.gjsRef.nativeElement,
      height: '80vh',
      width: '100%',
      storageManager: false,
      richTextEditor: { custom: true },
      plugins: ['grapesjs-preset-newsletter', customRTE],
      pluginsOpts: { 'grapesjs-preset-newsletter': {} },
      canvas: {
        // any  style sheets here are imported and used for the canvas ONLY
        styles: [
          "https://cdn.ckeditor.com/ckeditor5/46.1.1/ckeditor5.css"
        ] 
   },
    });

    // const gjs = this.editor;

    // (optional) a starter text so you can double-click and see CK balloon
    this.editor.addComponents(
      `<div style="padding:16px; font-family:system-ui; line-height:1.45;">
        <h2 data-gjs-type="text" style="margin:0 0 8px;">Click & edit</h2>
        <p data-gjs-type="text">This paragraph uses Grapes’ text component. When you edit it, CKEditor’s balloon toolbar should appear.</p>
      </div>`
    );

    /** Only stop GrapesJS at the iframe level when events originate inside CK editable */
    const installIframeEditableGuard = (ck: any, gjsLocal: Editor) => {
      const iDoc: Document | null = (gjsLocal as any)?.Canvas?.getDocument?.() || null;
      if (!iDoc) return;

      const editableEl: HTMLElement | null = ck.ui?.getEditableElement?.() ?? null;
      if (!editableEl) return;

      const guard = (e: Event) => {


        const t = e.target as HTMLElement | null;
        if (t?.tagName === 'IMG') {
          //comment return to make "drag" functionality work again at expense of image toolbar
          return
        }
        // If the click is inside CK’s editable, don't let Grapes intercept it.
        if (t && editableEl.contains(t)) 
          e.stopPropagation();
      };

      iDoc.addEventListener('pointerdown', guard, true);
      iDoc.addEventListener('click', guard, true);
      iDoc.addEventListener('dragstart', guard, true);
      (ck as any)._iframeGuard = guard;
    };

    const removeIframeEditableGuard = (ck: any, gjsLocal: Editor) => {
      const iDoc: Document | null = (gjsLocal as any)?.Canvas?.getDocument?.() || null;
      const guard = (ck as any)?._iframeGuard as any;
      if (iDoc && guard) {
          iDoc.removeEventListener('pointerdown', guard, true);
          iDoc.removeEventListener('click', guard, true);
          iDoc.removeEventListener('dragstart', guard, true);

      }
      (ck as any)._iframeGuard = null;
    };


    function placePoweredByOnEditable(ck: any, gjs: Editor) {
      const iDoc: Document | null = (gjs as any)?.Canvas?.getDocument?.() || null;
      const editable = ck.ui?.getEditableElement?.() as HTMLElement | null;
      if (!iDoc || !editable) return;

      // Find the watermark balloon wherever CK put it.
      const fromTop = document.querySelector('.ck-powered-by-balloon') as HTMLElement | null;
      const fromIfr = iDoc.querySelector('.ck-powered-by-balloon') as HTMLElement | null;
      const badge = fromIfr || fromTop;
      if (!badge) return;

      // Ensure the editable can anchor absolute children.
      const wasPos = editable.style.position;
      if (getComputedStyle(editable).position === 'static') {
          editable.style.position = 'relative';
      }

      // Move under the editable and pin it.
      if (!editable.contains(badge)) editable.appendChild(badge);
      Object.assign(badge.style, {
        position: 'absolute',
        right: '8px',
        bottom: '8px',
        left: 'auto',
        top: 'auto',
        transform: 'none',
        zIndex: '99999'
      });

      // If CK re-renders panels on selection/readOnly changes, keep it in place.
      if (!(ck as any)._poweredByPinned) {
        (ck as any)._poweredByPinned = true;
        const vdoc = ck.editing.view.document;
        const rePin = () => placePoweredByOnEditable(ck, gjs);
        vdoc.on('selectionChangeDone', rePin);
        ck.on('change:isReadOnly', rePin);
      }
    }


    // 3) Minimal CK-as-RTE wiring: create on enable, set readOnly on disable
    const resolveEditableEl = (el: HTMLElement): HTMLElement => {
      // If a wrapper (TD, etc.) gets passed, pick a child text container
      const tag = el.tagName.toUpperCase();
      if (['TABLE','TBODY','TR','TD','TH','SECTION','ARTICLE'].includes(tag)) {
        const cand = el.querySelector('p, div, span, h1, h2, h3, h4, h5, h6') as HTMLElement | null;
        if (cand) return cand;
      }
      return el;
    };

  }

  ngOnDestroy(): void {
    // (optional) destroy CK instances if you want to be extra tidy
    // for (const [el, ck] of Array.from(this.ckInstances as any)) { ck?.destroy?.(); }
    this.editor?.destroy();
    this.editor = undefined;
  }
}
